export default class ByteUtil {
    static intToBytes(n) {
        var buffer = new ArrayBuffer(4);
        var dv = new DataView(buffer);
        dv.setInt32(0, n);
        return new Uint8Array(buffer);
    }
    static intArrToBytes(n) {
        var buffer = new ArrayBuffer(4 * n.length);
        var dv = new DataView(buffer);
        for (var i = 0; i < n.length; i++) {
            dv.setInt32(i * 4, n[i]);
        }
        return new Uint8Array(buffer);
    }
    static unionUint8Array(n) {
        let bytes = new Array();
        for (var i = 0; i < n.length; i++) {
            for (var j = 0; j < n[i].length; j++) {
                bytes.push(n[i][j]);
            }
        }
        return new Uint8Array(bytes);
    }
    static dataViewToInt(data, index) {
        let dateView = new DataView(data);
        return dateView.getInt32(index);
    }
}
//# sourceMappingURL=byteUtil.js.map